import { Injectable, NgZone } from '@angular/core';
// import { AngularFireAuth } from '@angular/fire/auth';
import { Router } from '@angular/router';
import { Storage } from '@ionic/storage';
// import { auth } from 'firebase/app';
import { Credential } from 'src/app/models/Credential';
import { IAuthTokenDto } from 'src/app/models/interfaces/IAuthTokenDto';
import { IdTokenDto } from 'src/app/models/interfaces/IdTokenDto';
import { FirebaseUser } from 'src/app/models/FirebaseUser';

@Injectable({
	providedIn: 'root'
})
export class FirebaseAuthService {

	constructor(
		// private auth: AngularFireAuth,
		private router: Router,
		private storage: Storage,
		private ngZone: NgZone) {

		// this.listenAuthStateChange();
	}

	// listenAuthStateChange() {
	// 	this.auth.authState.subscribe(
	// 		async (x) => {
	// 			if (x) {
	// 				let provider = "password";

	// 				if (x.providerData.length > 0) {
	// 					provider = x.providerData[0].providerId;
	// 				}
	// 				await x.getIdToken().then((k) => {
	// 					this.setUser(x, provider, k, x.refreshToken);
	// 				});

	// 			} else {
	// 				this.FirebaseUser = null;
	// 			}
	// 		});
	// }

	// async signInWithEmail(user: Credential) {
	// 	return this.auth.auth.signInWithEmailAndPassword(user.email, user.password)
	// 		.then(
	// 			async (x) => {

	// 				await x.user.getIdToken().then((k) => {
	// 					this.setUser(x.user, x.additionalUserInfo.providerId, k, x.user.refreshToken);
	// 				});

	// 				return this.FirebaseUser;
	// 			},
	// 			error => {
	// 				return false;
	// 			});
	// }

	// async signUpWithEmail(user: Credential) {
	// 	return this.auth.auth.createUserWithEmailAndPassword(user.email, user.password).then(
	// 		async (x) => {
	// 			await x.user.updateProfile({ displayName: `${user.firstName} ${user.lastName}` });
	// 			await this.signInWithEmail(user);
	// 			return true;
	// 		},
	// 		error => {
	// 			return false;
	// 		}
	// 	);
	// }

	async logOut() {
		// return this.auth.auth.signOut().then(
			// async (x) => {
				localStorage.clear();
				this.storage.clear();
				window.dispatchEvent(new CustomEvent("user:loggedOut"))
				this.router.navigate(["sign-in"]);
				return true;
			// },
			// error => {
			// 	return false;
			// }
		// );
	}

	get FirebaseUser(): FirebaseUser {
		const user = localStorage.getItem("FirebaseUser");
		if (user != null) {
			return JSON.parse(user) as FirebaseUser;
		}
		return null;
	}

	set FirebaseUser(value: FirebaseUser) {
		if (value == null) {
			localStorage.removeItem("FirebaseUser");
		}
		localStorage.setItem("FirebaseUser", JSON.stringify(value));
	}

	// public signInGoogle() {
	// 	return this.providerAuthLogin(new auth.GoogleAuthProvider());
	// }

	// signInFacebook() {
	// 	return this.providerAuthLogin(new auth.FacebookAuthProvider());
	// }

	// providerAuthLogin(provider) {
	// 	return this.auth.auth.signInWithPopup(provider)
	// 		.then(
	// 			async (result) => {
	// 				console.log(result);
	// 				await result.user.getIdToken().then((k) => {
	// 					this.setUser(result.user, result.credential.providerId, k, result.user.refreshToken);
	// 				});

	// 				//this.redirectToDashboard();

	// 				return this.FirebaseUser;

	// 			}).catch((error) => {
	// 				console.log(error);
	// 				return false;
	// 			});
	// }

	setUser(userInfo, provider: string, token: string = null, refreshToken: string = null) {

		const user = new FirebaseUser();
		user.displayName = userInfo.displayName;
		user.email = userInfo.email;
		user.emailVerified = userInfo.emailVerified;
		user.photoUrl = userInfo.photoURL;
		user.uid = userInfo.uid;
		user.provider = provider;
		user.token = token;
		user.refreshToken = refreshToken;

		this.FirebaseUser = user;

		this.setTokens(user);

		window.dispatchEvent(new CustomEvent("user:loggedIn"));

		return user;
	}

	redirectToDashboard() {
		this.ngZone.run(() => {
			this.router.navigate(['dashboard']);
		});
	}

	setTokens(user: FirebaseUser) {
		const idToken: IdTokenDto = {};
		idToken.name = user.displayName;
		idToken.email = user.email;
		idToken.sub = user.provider;
		this.IdToken = idToken;
	}

	// IdToken
	get IdToken(): IdTokenDto {
		let a: IdTokenDto = JSON.parse(localStorage.getItem('homeazzon_backoffice_IdToken'));
		if (a == undefined || a == null) {
			return null;
		}
		return a;
	}

	set IdToken(value: IdTokenDto) {
		localStorage.setItem('homeazzon_backoffice_IdToken', JSON.stringify(value));
	}

	// AuthToken
	get AuthToken(): string {
		let a: any = localStorage.getItem('homeazzon_backoffice_AuthToken');

		if (a == undefined || a == null) {
			return null;
		}

		return a;
	}

	set AuthToken(value: string) {
		localStorage.setItem('homeazzon_backoffice_AuthToken', value);
	}

	get IsAuthenticated(): boolean {
		if (this.AuthToken != null) {
			return true;
		}

		return false;
	}


}
